import Icons from './utils/Icons';
import Swiper from 'swiper/bundle';
class Main {
  constructor() {
    this.init();
  }

  //Ce init appelle tous les autres init.
  init() {
    Icons.load();
    this.initSwiperPartenaires();
    this.initSwiperImages();
    this.initSwiperCards();
    this.initNavOpen();
    this.initNavClose();
    this.initResetNav();
  }

  //Voici le code pour le swiper des partenaires dans index.html.
  initSwiperPartenaires() {
    const target = document.querySelector('.js-partenaires');

    //Le code suivant sera exécuté seulement si l'élément target existe (donc si on se trouve dans la bonne page).
    if (target) {
      const swiper = new Swiper(target, {
        slidesPerView: 7,
        spaceBetween: 50,
        autoplay: { delay: 0, disableOnInteraction: false },
        speed: 4000,
        freeMode: true,
        loop: true,
      });
    }
    console.log('Joyeuses fêtes !');
  }

  //Voici le code pour le swiper des images dans la section autres-conferences de la page conferenciers.html.
  initSwiperImages() {
    const target = document.querySelector('.js-swiper-images');

    //Le code suivant sera exécuté seulement si l'élément target existe (donc si on se trouve dans la bonne page).
    if (target) {
      const swiper = new Swiper(target, {
        slidesPerView: 1,
        breakpoints: { 480: { slidesPerView: 1.2 } },
        spaceBetween: 20,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      });
    }
  }

  //Voici le code pour le swiper des cards dans la section autres-conferenciers de la page conferenciers.html.
  initSwiperCards() {
    const target = document.querySelector('.js-swiper-cards');

    //Le code suivant sera exécuté seulement si l'élément target existe (donc si on se trouve dans la bonne page).
    if (target) {
      const swiper = new Swiper(target, {
        slidesPerView: 1.1,
        breakpoints: { 480: { slidesPerView: 2 }, 1000: { slidesPerView: 3 } },
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      });
    }
  }

  //Voici le init qui contient l'écouteur d'évènements qui ouvre la nav mobile.
  initNavOpen() {
    const bouton = document.querySelector('.js-toggle');
    bouton.addEventListener('click', this.onOpenNav);
  }

  //Voici la méthode qui ouvre la nav mobile.
  onOpenNav() {
    document.documentElement.classList.add('nav-is-active');
  }

  //Voici le init qui contient l'écouteur d'évènements qui ferme la nav mobile.
  initNavClose() {
    const bouton2 = document.querySelector('.js-close');
    bouton2.addEventListener('click', this.onCloseNav);
  }

  //Voici la méthode qui ferme la nav mobile.
  onCloseNav() {
    document.documentElement.classList.remove('nav-is-active');
  }

  //Voici le init qui contient l'écouteur d'évènements qui ferme la nav mobile même si le lien cliqué amène à la même page.
  initResetNav() {
    const elementNav = document.querySelectorAll('.js-nav-element');
    for (let i = 0; i < elementNav.length; i++) {
      elementNav[i].addEventListener('click', this.resetNav);
    }
  }

  //Voici la méthode qui ferme la nav mobile même si le lien cliqué amène à la même page.
  resetNav() {
    document.documentElement.classList.remove('nav-is-active');
  }
}

new Main();
